module.exports = __webpack_public_path__ + "static/media/clock.8bb631fe.png";